<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->


<template>
  <div class="wy-interactions-contact-reason-transcripts-section" v-loading="loading">
    <div v-if="transcriptSearchAvailable">
      <!-- <div class="transcript-search-header">
        <p class="title">Transcript Search
          <img class="transcript-search-info-icon" src="../../../assets/icons/icon_info.svg">
        </p>
        <el-button  class="submit-btn export-btn" round @click="transcriptSearchResultsComponent && transcriptSearchResultsComponent.applyExport">
          <img src="../../../assets/icons/icon_intent_action_export_arr.svg" alt="">
          <span class="export-text">Export</span> 
        </el-button> 
      </div> -->
      <wy-transcript-search-filters ref="transcriptSearchFilters" :controller="module" :contactReason="parent.currentItem.topicDisplayName" :class="isTranscriptExpanded ? 'transcript-filter-hidden': ''" />
      <wy-transcript-search-results ref="transcriptSearchResults" :controller="module" :contactReason="parent.currentItem.topicDisplayName" @handle-transcript-click="handleTranscriptExpand" from="Conversation Topics"/>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions, mapMutations } from 'vuex';
// import WyUtils from '../../library/wy-utils.js';
import WyTranscriptSearchFilters from "./wy-interactions-transcript-search-filters";
import WyTranscriptSearchResults from "./wy-interactions-transcript-search-results";

export default Vue.extend({
  name: 'wy-interactions-contact-reasons-detail-transcripts',
  props: ['parent', 'activeTab'],
  components: {
    'wy-transcript-search-filters': WyTranscriptSearchFilters,
    'wy-transcript-search-results': WyTranscriptSearchResults,
  },

  data() {
    return {
      module: this,
      loading: false,
      //initDate: null,
      
      transcriptSearchAvailable: true,
      contactReason: null,

      isTranscriptExpanded: false,
      fetchData: true
    }
  },

  computed: {
    ...mapGetters(['dataModel', 'transcriptInfoReference']),
  },

  methods: {
    ...mapActions(['fetchTranscriptSearchTimeRange']),
    ...mapMutations(['updateTranscriptInfoReference']), //handle transcript info

    handleTranscriptPopover(e) {
      if (this.transcriptInfoReference) {
        this.transcriptInfoReference.visible = false;
        this.updateTranscriptInfoReference(null);
      }

      this.advancedFilterHideEvent(e);
    },

    startLoading() {
      // this.initDate = new Date();
      // if(!this.loading) {
      //   this.logEventLoaded();
      // }
      this.loadTranscriptsData(true);
    },

    // logEventLoaded() {
    //   if(this.initDate) {
    //     this.initDate = null;
    //   }
    // },

    async loadTranscriptsData(firstTime, eventType) {
      // this.$root.$emit(`fire-global-filter-change-events`, true);
      if (this.fetchData && (!this.loading && this.dataModel.dateEnd || this.dataModel.dateEnd)) {
        this.fetchData = false;
        document.getElementById('pane-conversations').style['overflow'] = 'hidden';
        this.loading = true;
        this.transcriptSearchAvailable = true;
        let timeRangeResult = await this.fetchTranscriptSearchTimeRange({topicDisplayName: this.parent.currentItem.topicDisplayName, isOthers: this.parent.currentItem.isOthers});
        // do the search when timeRangeResult's range time is not -1 && must have contact reasons
        if(timeRangeResult && timeRangeResult.data 
        && timeRangeResult.data.minAgentHandlingTime > -1 && timeRangeResult.data.maxAgentHandlingTime > -1
        && timeRangeResult.data.minAgentResponseTime > -1 && timeRangeResult.data.maxAgentResponseTime > -1 
        && this.$refs.transcriptSearchResults) {
          this.$refs.transcriptSearchResults.prepareTimeRange(timeRangeResult);
          if(firstTime) this.$refs.transcriptSearchResults.loadTopicConversations(1, false, eventType);
        }
        else {
          this.transcriptSearchAvailable = false;
          this.loading = false;
          document.getElementById('pane-conversations').style['overflow'] = 'auto';
        }
      }
    },
    handleTranscriptExpand(value) {
      this.isTranscriptExpanded = value;
    },
    handleClickOnPage() {
      if(this.$refs.transcriptSearchFilters.showAllFilters && !this.$refs.transcriptSearchFilters.triggeredFromAllFiltersBtn) {
        this.$refs.transcriptSearchFilters.showAllFilters = false;
      }
      if(this.$refs.transcriptSearchFilters.showAgentFilters && !this.$refs.transcriptSearchFilters.triggeredFromAgentFiltersBtn) {
        this.$refs.transcriptSearchFilters.showAgentFilters = false;
      }
      this.$refs.transcriptSearchFilters.triggeredFromAllFiltersBtn = false;
      this.$refs.transcriptSearchFilters.triggeredFromAgentFiltersBtn = false;
    },
    advancedFilterHideEvent(e) {
      const ref = this.$refs.transcriptSearchFilters;
      const refMethodExists = ref && ref.handleClickOutsideOfPopover;
      const refPopoverIsShowing = ref && ref.showAdvancedSearchFilter;

      if (refMethodExists && refPopoverIsShowing) {
        const targetClassList = e && e.target && e.target.classList;
        const isSearchInputClicked = ['search-inp', 'el-input', 'el-input__inner', 'advanced-search-icon'].some((className) => targetClassList && targetClassList.contains(className));
        const isSearchInputUndefined = targetClassList === undefined;

        if (isSearchInputClicked || isSearchInputUndefined) {
          ref.showAdvancedSearchFilter = true;
          return;
        } else {
          ref.handleClickOutsideOfPopover();
        }
      }
    },
  },

  watch: {
    async activeTab() {
      if (this.activeTab === 'conversations' && !this.loading) {
        this.fetchData = true;
        await this.loadTranscriptsData(true)
        this.fetchData = false;
      }

      const ref = this.$refs.transcriptSearchFilters
      if (ref) {
        ref.handleCancelAllfilters();
      }
    },
  },

  created() {
    // listen events from other components
    this.$root.registerPageEvent(this.$route.name, (event) => {
      if (this[event.name]) this[event.name]();
    });
    // await this.loadTranscriptsData(true);
  },

  mounted() {
    // on resize window, we close the transcript popover
    window.addEventListener('resize', (e) => {
      this.handleTranscriptPopover(e);
    });

    // on scroll, we close the transcript popover & any opened dropdowns
    document.querySelector('.wy-interactions-contact-reasons-detail .wy-page-tab #pane-conversations').addEventListener('scroll', (e) => {
      this.handleTranscriptPopover(e);
    });

    // Outside of metric-analysis
    document.addEventListener('click', (e) => {
      this.handleTranscriptPopover(e);
    });

    // Inside metric-analysis
    document.querySelector('.wy-interactions-contact-reason-transcripts-section').addEventListener('click', (e) => {
      this.handleTranscriptPopover(e);
    });
  }
});
</script>

<style lang="scss">
.wy-interactions-contact-reason-transcripts-section {
  padding: 15px 25px 15px 25px;
  white-space: clip;
  overflow: visible;
  height: calc(100vh - 298px);
  min-width: 1065px;

  .tryAgainBtn {
    display: flex !important;
    align-items: flex-start !important;
  }

  .submit-btn.export-btn {
    background: transparent;
    box-sizing: border-box;
    border-radius: 5px;
    border: 1px solid #CAD2DA !important;
    padding: 6px 15px 9px 11px !important;
    width: 90px;
    font-size: 16px !important;
    height: 39px;
    font-weight: 500 !important;
    color: var(--site-font-tertiary-color) !important;
    float: right;
    &:hover{
      background-color: #F4F6F8;
    }
  }
  .div-transcripts-viewer-content {
    // height: calc(100vh - 406px) !important;
    height: calc(100vh - 460px) !important;
    min-height: 366px;

    .div-transcript-details {
      // min-height: 367px;
      height: 100% !important;
    }
  }
  .export-text{
    margin-top: 2px;
    position: relative;
    bottom: 1px;
    left: 5px;
    font-weight: 500 !important;
  }
  .transcript-search-header{
    display: flex;
    height: 50px;
    margin-top: 12px;
    justify-content: space-between;
    align-items: center;
    .transcript-buttons {
      margin-left: auto;
    }
  }
  .transcript-search-info-icon{
    width: 14px;
    margin-bottom: 2px;
  }
  .title {
    color: var(--site-font-secondary-color);
    font-size: 25px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 600;
  }

  .flex-container{
    display: flex;
    justify-content: space-around;
    position: relative;
    left: 20px;
  }
  .transcripts-viewer-header-right {
    overflow-y: auto;
    height: 204px !important;
    padding-right: 20px;

    &::-webkit-scrollbar {
      background-color: #000 !important;
      width: 8px !important;
    }
    &::-webkit-scrollbar-thumb{
      background: #C8C8C8 !important;
      border-radius: 5px;
    }
  }
  .contact-reason-transcript-tab-info-pop-over{
    padding: 12px 7px 10px 15px !important;
  }
  .sentiment-icon-positive{
    cursor: pointer;
    background-image: url('../../../assets/icons/icon_positive_senti.svg');
    background-size: 80%;
    background-repeat: no-repeat;
    background-position-y: 3px;
    background-position-x: 5px;
    position: relative;
    left: -2px;
    top: 0px;
    border-radius: 100px;
    border: 0px;
    margin: 6px 13px 0 0;
    padding: 12px 10px 14px 14px;
    float: left;
  }
  .sentiment-icon-neutral{
    cursor: pointer;
    background-image: url('../../../assets/icons/icon_neutral_senti.svg');
    background-size: 80%;
    background-repeat: no-repeat;
    background-position-y: 3px;
    background-position-x: 5px;
    position: relative;
    left: -2px;
    top: 0px;
    border-radius: 100px;
    border: 0px;
    margin: 6px 13px 0 0;
    padding: 12px 10px 14px 14px;
    float: left;
  }
  .sentiment-icon-negative{
    cursor: pointer;
    background-image: url('../../../assets/icons/icon_negative_senti.svg');
    background-size: 80%;
    background-repeat: no-repeat;
    background-position-y: 3px;
    background-position-x: 5px;
    position: relative;
    left: -2px;
    top: 0px;
    border-radius: 100px;
    border: 0px;
    margin: 6px 13px 0 0;
    padding: 12px 10px 14px 14px;
    float: left;
  }
  .contact-reason-transcript-tab-info-pop-over{
    background: black;
    color: #FFFFFF;
    border: black !important;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  }
  .div-transcript-viewer-header {
    padding: 5px 5px 13px 5px;
    font-weight: 500;
    display: inline-flex;
    width: -webkit-fill-available;
    padding-right: 0px;

    .div-header-title {
      width: 100%;
    }
    .div-transcript-search {
      width: 300px;
      float: right;
      background: #FFFFFF 0% 0% no-repeat padding-box;
      // box-shadow: 0px 3px 6px #00000029;
      border: 1px solid #D7D7D8;
      border-radius: 100px;
      height: 30px;
      opacity: 1;
      overflow: hidden;

      input {
        border-radius: 19px;
        height: 30px;
        padding-left: 17px;
      }
      .el-input__icon.el-icon-click {
        background-image: url('../../../assets/icons/icon_search.svg');
        background-repeat: no-repeat;
        background-size: 18px 18px;
        background-position-y: 5px;
        background-position-x: 0px;
      }
      .el-input__inner:focus {
        border-color: #FFF;
        outline: 0;
      }
    }
    .transcript-filter {
      margin-right: 5px;
      padding-top: 3px;
      height: 20px;
      input.el-input__inner {
        border-width: 0px 0px 0px 0px !important;
        color: #002852;
        font-weight: bold;
        width: 200px;  // fit-content doesn't work well for some reason after bolding the text
        text-align: right;
        &::placeholder {
          color: #002852;
        }
      }
      .el-input .el-select__caret{
        color: #002852;
        font-weight: bold;
      }
      .el-icon-arrow-up:before {
          content: "\E78F";
      }
    }

  }

  .div-transcripts-viewer-header {
    padding: 0px 0px;
    font-weight: 500;
  }

  .div-transcripts-viewer-content {
    display: inline-flex;
    height: calc(100vh - 356px);
    width: 100%;
    .el-table__body-wrapper {
      overflow-x: hidden;
      overflow-y: auto;
      height: 240px;
    }
    .page-content:last-child {
      margin: 0px;
    }
    .page-content {
      border: 0.5px solid var(--unnamed-color-cbcbcb);
      background: #FFFFFF 0% 0% no-repeat padding-box;
      border: 0.5px solid #E8E8E8;
      border-radius: 10px;
      height: calc(100vh - 354px);
      min-width: 257px;
      width: 25%;
      margin: 0px 15px 0px 0px;
      // overflow-y: auto;
      // overflow-x: hidden;

      .div-transcript-header {
        height: 36px;
        border-bottom: 1px #E8E8E8 solid;
        display: inline-block;
        min-width: 257px;
        width: 100%;
        background-color: #F5F6F7;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;

        .transcripts-viewer-header-left {
          float: left;
          width: 84%;
        }

        .transcripts-viewer-date-header {
          display: inline-block;
          font-size: 14.22px;
          font-weight: 400;
          padding-left: 10px;
          padding-top: 12px;
        }
        .transcripts-viewer-time-header {
          float: right;
          font-size: 14.22px;
          font-weight: 400;
          padding-left: 0px;
          margin-right: 9px;
          width: 100px;
        }
        .el-button:focus {
          background-color: unset
        }
        .el-button:hover {
          background-color: unset;
        }
      }
      .div-transcript-content {
        // height: 328px;
        height: calc(100vh - 405px);
        min-width: 257px;
        width: 100%;
        padding: 0px 0px;
        overflow-y: auto;
        overflow-x: hidden;
        font-size: 12px;
        &::-webkit-scrollbar {
          width: 20px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 160px;
          border: 2px solid transparent;
          border-top: 4px solid transparent;
          background-clip: content-box;
          background-color: #CAD2DA;
        }
        &::-webkit-scrollbar-track {
          background:#fff;
          border-top: 1px solid #CAD2DA;
        }
        &::-webkit-scrollbar:vertical {
          width: 14px;
        }
        &::-webkit-scrollbar-thumb:vertical {
          border-radius: 160px;
          border: 2px solid transparent;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          background-clip: content-box;
          background-color: #CAD2DA;
        }
        &::-webkit-scrollbar-track:vertical {
          //border-left: 1px solid #CAD2DA;
          border-top: none !important;
        }

        .div-transcript-row {
          display: inline-flex;
          padding: 10px 15px 8px 11px;
          border-bottom: 1px #E8E8E8 solid;
          min-width: 245px;
          width: 100%;
          cursor: default;

          .div-sent-by {
            font-weight: 500;
            padding-right: 10px;
            min-width: 33px;
            line-height: 14px;
          }
          .div-transcript-text {
            word-break: break-word;
            // min-width: 178px;
            width: 80%;
            padding-right: 11px;
          }
        }
        .div-transcript-row:hover {
          background: #f5f7fa;
        }
      }
    }

    .el-loading-mask {
      height: unset !important;
      opacity: 0.9;
      border-radius: 10px;

      .el-loading-spinner .el-loading-text {
        display: none;
      }
      .el-loading-spinner {
        top: 35%;
        background: var(--site-loading-icon);
        background-repeat: no-repeat;
        background-size: 25px;
        background-position: center;    
        .circular {
          display: inline-block;
          width: 90px;
          height:  90px; 
        }
      }
      .el-loading-spinner .path {
        -webkit-animation: loading-dash 2s ease-in-out infinite;
        animation: loading-dash 2s ease-in-out infinite;
        stroke-dasharray: 90,150;
        stroke-dashoffset: 0;
        stroke-width: 2.5 !important;
        stroke: #0C2837 !important;
        stroke-linecap: round;
      }
    }
  }
  .wy-interactions-transcript-search-details {
    .el-tooltip.info-item {
      line-height: 0;
      left: 12px;
    }
    span .el-infor-icon {
      background-image: url('../../../assets/icons/icon_transcript_search_info.svg') !important;
      left: -11px;
      top: 5px;
    }
    .div-transcript-content {
      min-height: 322px;
    }
  }

  .div-transcripts-viewer-footer {
    display: inline-block;
    width: 100%;

    .div-transcript-page-infor {
      float: left;
      padding-left: 10px;
      padding-top: 13px;
      font-size: 12px;
      line-height: 28px;
      color: #ADADAD;
    }
    .div-transcript-pagination {
      float: right;
      padding-right: 0px;
      padding-top: 10px;
      
      .el-pagination {
        padding-right: 0px;
      }
      .el-pagination button {
        color: #002852;
        font-weight: bold;
        padding-right: 0px;
        padding-left: 30px;
      }
      .el-pagination button:disabled {
        color: #C0C4CC;
      }
      .el-pagination span:not([class*=suffix]) {
        word-spacing: 7px;
      }
    }
  }

  ul.el-pager {
    display: none;
  }

  .wy-interactions-transcript-search-results {
    margin-bottom: 0px;
  }
}
.transcript-filter-dropdown {
  .el-select-dropdown__item {
    color: var(--site-font-primary-color) !important;
  }
} 

.contact-reason-transcript-tab-info-pop-over {
  font-size: 13px;
  width: fit-content !important;
  padding: 12px 7px 10px 15px;
  box-shadow: 0px 0px 20px #0000002E;
  border-radius: 10px;
  color: #E4E8EC;
  line-height: 18px;
  .popper__arrow {
    display: block !important;
    
    &:after{
      display: block !important;
      border-bottom-color: #000 !important;
    }
  }
}



</style>